import { render } from "./Security_Profile_Dialog.vue?vue&type=template&id=62603b28&ts=true"
import script from "./Security_Profile_Dialog.vue?vue&type=script&lang=ts"
export * from "./Security_Profile_Dialog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__